module.exports = __webpack_public_path__ + "static/media/logounicred.1c74b06a.png";